import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '../../Button/index.js';
import { ChartDownloadDropdown } from './chart-download-dropdown.js';
var _excluded = ["hide", "className", "style"];

var createToolbarButtons = function createToolbarButtons(buttons) {
  return buttons === null || buttons === void 0 ? void 0 : buttons.map(function (_ref, index) {
    var hide = _ref.hide,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? 'chart-toolbar-button' : _ref$className,
        _ref$style = _ref.style,
        style = _ref$style === void 0 ? 'link' : _ref$style,
        config = _objectWithoutProperties(_ref, _excluded);

    return !hide && /*#__PURE__*/React.createElement(Button, _extends({
      key: index,
      className: className,
      style: style
    }, config));
  });
};

var ChartToolbar = function ChartToolbar(props) {
  if (!props.show) {
    return null;
  }

  var buttons = props.buttons,
      canDownloadReport = props.canDownloadReport,
      toolbarType = props.toolbarType,
      onSelectDownload = props.onSelectDownload,
      style = props.style,
      pollingExport = props.pollingExport,
      exportAvailability = props.exportAvailability;
  var toolbarButtonVariant = toolbarType === 'light' ? 'link' : 'primary';
  return /*#__PURE__*/React.createElement("div", {
    className: "chart-toolbar",
    style: style
  }, createToolbarButtons(buttons), /*#__PURE__*/React.createElement(ChartDownloadDropdown, {
    canDownloadReport: canDownloadReport,
    exportAvailability: exportAvailability,
    onSelect: onSelectDownload,
    pollingExport: pollingExport,
    toolbarButtonVariant: toolbarButtonVariant
  }));
};

ChartToolbar.displayName = "ChartToolbar";
export { ChartToolbar };